import { makeStyles } from "@material-ui/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";

export default makeStyles(theme => ({
  logotype: {
    color: "white",
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
    fontWeight: 500,
    fontSize: 18,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  logoImage: {
    width: 50,
  },
  appBar: {
    width: "100vw",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  grow: {
    flexGrow: 1,
  },
  groupSelectWrapper: {
    display: "flex",
    alignItems: "center",
    // On phones/small tablets this moves into the sidebar drawer (the toolbar
    // has no room for it), matching where the sidebar becomes a temporary drawer.
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  groupSelectLabel: {
    color: "white",
    marginRight: theme.spacing(1),
    whiteSpace: "nowrap",
    fontSize: 16,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  joinGroupItem: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    fontWeight: 600,
    justifyContent: "center",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  groupSelect: {
    color: "white",
    fontSize: 18,
    fontWeight: 500,
    border: "1px solid rgba(255, 255, 255, 0.7)",
    borderRadius: 4,
    "& .MuiSelect-icon": {
      color: "white",
    },
    "& .MuiSelect-select": {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "transparent",
    },
  },
  search: {
    position: "relative",
    borderRadius: 25,
    paddingLeft: theme.spacing(2.5),
    width: 36,
    backgroundColor: alpha(theme.palette.common.black, 0),
    transition: theme.transitions.create(["background-color", "width"]),
    "&:hover": {
      cursor: "pointer",
      backgroundColor: alpha(theme.palette.common.black, 0.08),
    },
  },
  searchFocused: {
    backgroundColor: alpha(theme.palette.common.black, 0.08),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 250,
    },
  },
  searchIcon: {
    width: 36,
    right: 0,
    height: "100%",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: theme.transitions.create("right"),
    "&:hover": {
      cursor: "pointer",
    },
  },
  searchIconOpened: {
    right: theme.spacing(1.25),
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    height: 36,
    padding: 0,
    paddingRight: 36 + theme.spacing(1.25),
    width: "100%",
  },
  messageContent: {
    display: "flex",
    flexDirection: "column",
  },
  langSwitcher: {
    display: "flex",
    alignItems: "center",
    // Sits at the far right of the toolbar, after the account icon, with a gap
    // separating it from that icon.
    marginLeft: theme.spacing(3),
    // On phones/small tablets this moves into the sidebar drawer alongside the
    // group picker, so the toolbar doesn't overflow.
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  langFlag: {
    width: 26,
    height: "auto",
    cursor: "pointer",
    borderRadius: 2,
    opacity: 0.4,
    transition: theme.transitions.create("opacity"),
    marginLeft: theme.spacing(0.5),
    "&:hover": {
      opacity: 0.8,
    },
  },
  langFlagActive: {
    opacity: 1,
    cursor: "default",
    outline: "2px solid white",
    "&:hover": {
      opacity: 1,
    },
  },
  headerMenu: {
    marginTop: theme.spacing(7),
  },
  headerMenuList: {
    display: "flex",
    flexDirection: "column",
  },
  headerMenuItem: {
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
      // color: "white",
    },
  },
  headerMenuButton: {
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0.5),
  },
  headerMenuButtonSandwich: {
    marginLeft: 9,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0
    },
    padding: theme.spacing(0.5),
  },
  headerMenuButtonCollapse: {
    marginRight: theme.spacing(2),
  },
  headerIcon: {
    fontSize: 28,
    color: "rgba(255, 255, 255, 0.35)",
  },
  headerIconCollapse: {
    color: "white",
  },
  profileMenu: {
    minWidth: 265,
  },
  profileMenuUser: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
  },
  profileMenuItem: {
    color: theme.palette.text.hint,
  },
  profileMenuIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.text.hint,
    '&:hover': {
      color: theme.palette.primary.main,
    }
  },
  profileMenuLink: {
    fontSize: 16,
    textDecoration: "none",
    "&:hover": {
      cursor: "pointer",
    },
  },
  messageNotification: {
    height: "auto",
    display: "flex",
    alignItems: "center",
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
    },
  },
  messageNotificationSide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginRight: theme.spacing(2),
  },
  messageNotificationBodySide: {
    alignItems: "flex-start",
    marginRight: 0,
  },
  sendMessageButton: {
    margin: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  sendButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  purchaseBtn: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
    marginRight: theme.spacing(3)
  }
}));
